import axios from "axios"

// const
export const EQUIPMENT_TYPE_ADD_INITIAL_DATA = "equipmentTypeAdd/EQUIPMENT_TYPE_ADD_INITIAL_DATA";
export const EQUIPMENT_TYPE_ADD_UPDATE_DATA = "equipmentTypeAdd/EQUIPMENT_TYPE_ADD_UPDATE_DATA";
export const EQUIPMENT_TYPE_ADD_TOGGLE_MODAL = "equipmentTypeAdd/EQUIPMENT_TYPE_ADD_TOGGLE_MODAL";
export const EQUIPMENT_TYPE_ADD_TOGGLE_LOADING = "equipmentTypeAdd/EQUIPMENT_TYPE_ADD_TOGGLE_LOADING";
export const EQUIPMENT_TYPE_ADD_TOGGLE_SELECT = "equipmentTypeAdd/EQUIPMENT_TYPE_ADD_TOGGLE_SELECT";

//modal const
export const EQUIPMENT_TYPE_ADD_MODAL_SUCCESS_TITLE = "scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_success_title";
export const EQUIPMENT_TYPE_ADD_MODAL_FAIL_TITLE = "scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_fail_title";
export const EQUIPMENT_TYPE_ADD_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_addSuccess_content";
export const EQUIPMENT_TYPE_ADD_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_addFail_content";
export const EQUIPMENT_TYPE_ADD_MODAL_OK_LABEL = "scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_OK_label";
export const EQUIPMENT_TYPE_ADD_MODAL_CANCEL_LABEL = "scenes_Equipment_EquipmentType_EquipmentTypeAdd_modal_cancel_label";

export const equipmentTypeAdd = (state = {
  loading: false,

  isAuthenticated: false,
  releaseUserId: "",
  releaseUserName: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  code: "",
  name: "",
  description: "",
  ifDynamic: true,
  ifEnabled: true,

}, action) => {
  switch (action.type) {
    case EQUIPMENT_TYPE_ADD_INITIAL_DATA:
      return {
        ...state,
        loading: false,
        modalVisible: false,
        code: "",
        name: "",
        description: "",
        ifDynamic: true,
        ifEnabled: true,
      };
    case EQUIPMENT_TYPE_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_TYPE_ADD_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_TYPE_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};


/**
 * update data based on user input
 */
export const updateEquipmentTypeAddData = (data) => {
  return {
    type: EQUIPMENT_TYPE_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init equipment type
 */
export const initEquipmentType = () => {
  return {
    type: EQUIPMENT_TYPE_ADD_INITIAL_DATA,
  }
};

/**
 * submit data
 * @deprecated since 20220909
 */
export const createEquipmentType = (data) => {
  return (dispatch) => {
    dispatch(toggleLoading(true));
    console.log(data);
    axios({
      method: "POST",
      url: "/api-equipment/submitEquipmentType",
      contentType: "application/json",
      withCredentials: true,
      data: {
        "name": data.name,
        "code": data.code,
        "description": data.description,
        "ifDynamic": data.ifDynamic,
        "createById": data.releaseUserId,
        "createByName": data.releaseUserName,
        "ifEnabled": true
      },
    }).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.status === 200) {
          console.info("success submit equipment type");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_TYPE_ADD_MODAL_SUCCESS_TITLE,
            modalContent: EQUIPMENT_TYPE_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
            modalOk: EQUIPMENT_TYPE_ADD_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_TYPE_ADD_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
              console.log(this.props)
              // this.props.history.goBack();
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
              this.props.history.goBack();
            }
          }));
        } else {
          console.error("fail to submit equipment type");
          dispatch(toggleModal({
            modalVisible: true,
            modalTitle: EQUIPMENT_TYPE_ADD_MODAL_FAIL_TITLE,
            modalContent: EQUIPMENT_TYPE_ADD_MODAL_SUBMIT_FAIL_CONTENT,
            modalOk: EQUIPMENT_TYPE_ADD_MODAL_OK_LABEL,
            modalCancel: EQUIPMENT_TYPE_ADD_MODAL_CANCEL_LABEL,
            onOk: () => {
              dispatch(toggleModal({modalVisible: false}));
            },
            onCancel: () => {
              dispatch(toggleModal({modalVisible: false}));
            }
          }));
        }
      }
    );
  };
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_TYPE_ADD_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_TYPE_ADD_TOGGLE_LOADING,
    data: show
  }
};


